import { endswith, startswith } from "@pdfking/workflow/utils/strings"
import composition from "rfuncs/functions/composition"

export default composition(
  (path: string): string => (endswith(path, "/") ? path : `${path}/`),
  (path: string): string => (startswith(path, "/") ? path : `/${path}`)
) as (path: string) => string
